import { RootState } from 'editor/src/store/index';

const getVariantWarnings = (state: RootState, productId: string) =>
  state.editorModules.warnings.variantWarnings[productId] || [];

export default getVariantWarnings;
